import { JSX } from "react";

import { IconProps } from "@/@types/general";

const IconSadFace = (props: IconProps): JSX.Element => (
  <svg viewBox="0 0 201 209" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M119.797 108.094L151.751 140.048L134.276 157.522L102.323 125.568L119.797 108.094Z" fill="#FEF5BD" />
    <path
      d="M152.004 128.299L190.967 167.261C194.912 171.206 194.912 177.613 190.967 181.558L175.173 197.351C171.228 201.296 164.822 201.296 160.877 197.351L121.915 158.388C117.97 154.443 117.97 148.037 121.915 144.092L137.708 128.299C141.653 124.354 148.059 124.354 152.004 128.299Z"
      fill="#FF7000"
    />
    <path
      d="M124.92 122.746C149.926 97.6041 149.9 56.8231 124.876 31.6544C99.8518 6.48575 59.2906 6.47258 34.2945 31.6134C9.28835 56.755 9.30464 97.5369 34.3378 122.695C59.3618 147.863 99.9137 147.887 124.92 122.746Z"
      fill="#55514D"
    />
    <path
      d="M41.9026 41.4079C61.6268 21.6838 93.6712 21.6993 113.414 41.4426C133.158 61.1858 133.173 93.2303 113.449 112.954C93.725 132.679 61.6806 132.663 41.9373 112.92C22.1941 93.1765 22.1785 61.132 41.9026 41.4079Z"
      fill="white"
    />
    <g opacity="0.92">
      <path
        d="M62.9614 63.4238C65.4411 63.4238 67.4545 67.261 67.4545 71.987C67.4545 76.7131 65.4411 80.5502 62.9614 80.5502C60.4816 80.5502 58.4683 76.7131 58.4683 71.987C58.4683 67.261 60.4816 63.4238 62.9614 63.4238Z"
        fill="black"
      />
    </g>
    <g opacity="0.92">
      <path
        d="M91.3022 63.4238C93.7819 63.4238 95.7953 67.261 95.7953 71.987C95.7953 76.7131 93.7819 80.5502 91.3022 80.5502C88.8224 80.5502 86.8091 76.7131 86.8091 71.987C86.8091 67.261 88.8224 63.4238 91.3022 63.4238Z"
        fill="black"
      />
    </g>
    <path
      d="M88.1851 97.0297C74.3598 90.1176 63.2783 97.8226 65.0987 97.4277C73.0595 95.7029 88.7159 97.2951 88.1851 97.0297Z"
      fill="#FF8E3A"
    />
    <path
      d="M72.8414 199.996C82.1508 199.996 89.7092 201.498 89.7092 203.348C89.7092 205.198 82.1508 206.699 72.8414 206.699C63.5321 206.699 55.9736 205.198 55.9736 203.348C55.9736 201.498 63.5321 199.996 72.8414 199.996Z"
      fill="#DEDDD7"
    />
  </svg>
);

export default IconSadFace;
